<template>
    <div>
        <div class="text_editor" />
    </div>
</template>

<script>
    import Quill from 'quill';

    export default {
        name: 'TextEditor',
        props: {
            value: {
                type: Array,
                default: () => {
                    return [];
                }
            }
        },
        data: () => ({
            editor: null,
            editorOptions: {
                modules: {
                    toolbar: [
                        [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
                        ['bold', 'italic', 'underline'],
                        ['blockquote'],
                        [{ 'indent': '-1' }, { 'indent': '+1' }],
                        [{ 'color': [] }],
                        [{ 'align': [] }],
                        ['clean']
                    ]
                },
                placeholder: 'Saisie du texte...',
                theme: 'snow'
            },
            tooltip: [
                { dataToogle: 'bold', title: 'Bold <cmd+b>' },
                { dataToogle: 'italic', title: 'Italic <cmd+i>' },
                { dataToogle: 'underline', title: 'Underline <cmd+u>' }
            ]
        }),
        mounted () {
            this.editor = new Quill(this.$el.querySelector('.text_editor'), this.editorOptions);
            this.editor.setContents(this.value);
            let container = this.$el.parentNode.querySelector('.ql-toolbar');
            this.tooltip.forEach((element) => {
                let iconContainer = container.querySelector('.ql-' + element.dataToogle);
                iconContainer.setAttribute('data-toggle', 'tooltip');
                iconContainer.setAttribute('title', element.title);
            });
            this.editor.on('editor-change', () => {
                this.$emit('input', this.editor.getContents().ops);
            });
        }
    };
</script>

<style scoped>
    .editor, .editor {
        font-size: initial !important;
    }
</style>
